import React, { Fragment, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import CheckIcon from "@mui/icons-material/Check";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";

import { AlertContext } from "../../../context/AlertContext";
import { AuthContext } from "../../../context/AuthContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import { getBrand, createBrandTheme } from "../../../theme/brand";
import Spinner from "../Spinner";
import Barra from "../Barra";
import CabeceraPantalla from "../common/CabeceraPantalla";

const Seccion = ({ titulo, children }) => (
  <Paper
    elevation={0}
    sx={{
      p: 3,
      mb: 2,
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 2,
    }}
  >
    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2 }}>
      {titulo}
    </Typography>
    <Grid container spacing={3} alignItems="center">
      {children}
    </Grid>
  </Paper>
);

export default function Parametros() {
  const { mensajeAlerta } = useContext(AlertContext);
  const { state, usuarioAutenticado } = useContext(AuthContext);
  const {
    statusAcceso,
    configuracion,
    obtenerAcceso,
    actualizarConfiguracion,
    obtenerConfiguracion,
    guardarConfiguracion,
  } = useContext(ConfiguracionContext);

  const navigate = useNavigate();
  const theme = createBrandTheme(getBrand(configuracion));

  useEffect(() => {
    usuarioAutenticado();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.id]);

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({ usuarioId: state.usuario.id, layout: "NumeroInterno" });
    }
    obtenerConfiguracion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.id]);

  useEffect(() => {
    if (statusAcceso === 400) {
      mensajeAlerta(
        "Accesos",
        "No tiene permiso para acceder a esta pantalla !.",
        "error",
      );
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusAcceso]);

  const set = (patch) => guardarConfiguracion({ ...configuracion, ...patch });

  const aceptarClick = (e) => {
    e.preventDefault();
    const { edadPediatrico, diurnoDesde, diurnoHasta } = configuracion;

    if (edadPediatrico === 0) {
      mensajeAlerta("Parámetros", "edad es necesario !.", "error");
      return;
    }
    if (diurnoDesde === "") {
      mensajeAlerta("Parámetros", "Diurno desde es necesario !.", "error");
      return;
    }
    if (diurnoHasta === "") {
      mensajeAlerta("Parámetros", "Diurno hasta es necesario !.", "error");
      return;
    }

    actualizarConfiguracion(configuracion);
  };

  const exitClick = () => navigate("/");

  const sinWhapi = configuracion && !configuracion.whapi;

  return (
    <Fragment>
      <Barra />

      {statusAcceso === 0 || statusAcceso === 400 ? <Spinner /> : null}

      {statusAcceso === 200 && configuracion ? (
        <ThemeProvider theme={theme}>
          <Box sx={{ px: { xs: 1, sm: 2 }, pb: 3, maxWidth: 1100, mx: "auto" }}>
            <CabeceraPantalla
              icono={<TuneOutlinedIcon />}
              titulo="Parámetros del sistema"
              onCerrar={exitClick}
            />

            <Seccion titulo="Horarios y generales">
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  id="edadPediatrico"
                  label="Edad Pediátrico hasta"
                  fullWidth
                  value={configuracion.edadPediatrico}
                  onChange={(e) => set({ edadPediatrico: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  id="diurnoDesde"
                  label="Servicio diurno desde"
                  type="time"
                  fullWidth
                  value={configuracion.diurnoDesde}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ step: 300 }}
                  onChange={(e) => set({ diurnoDesde: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  id="diurnoHasta"
                  label="Servicio diurno hasta"
                  type="time"
                  fullWidth
                  value={configuracion.diurnoHasta}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ step: 300 }}
                  onChange={(e) => set({ diurnoHasta: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  id="nocturnoDesde"
                  label="Servicio nocturno desde"
                  type="time"
                  fullWidth
                  disabled
                  value={configuracion.diurnoHasta}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ step: 300 }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  id="nocturnoHasta"
                  label="Servicio nocturno hasta"
                  type="time"
                  fullWidth
                  disabled
                  defaultValue={configuracion.diurnoDesde}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ step: 300 }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="farmacia"
                      checked={configuracion ? configuracion.medicamentos : false}
                      onChange={(e) => set({ medicamentos: e.target.checked })}
                    />
                  }
                  label="Utilizar carga de medicamentos en cierre del servicio"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="location"
                      checked={configuracion ? configuracion.location : false}
                      onChange={(e) => set({ location: e.target.checked })}
                    />
                  }
                  label="Habilitar geolocalización en celulares de móviles"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="alertas"
                      checked={configuracion ? configuracion.alertas : false}
                      onChange={(e) => set({ alertas: e.target.checked })}
                    />
                  }
                  label="Habilitar alertas en pantalla despachos"
                />
              </Grid>
            </Seccion>

            <Seccion titulo="Links Móviles Propios">
              <Grid item xs={12} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="movilesPantalla"
                      checked={
                        configuracion ? configuracion.movilespantalla : false
                      }
                      onChange={(e) => set({ movilespantalla: e.target.checked })}
                    />
                  }
                  label="Pantalla"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="movilesWhatsApp"
                      checked={
                        configuracion ? configuracion.movileswhatsapp : false
                      }
                      onChange={(e) => set({ movileswhatsapp: e.target.checked })}
                      disabled={sinWhapi}
                    />
                  }
                  label="WhatsApp"
                />
              </Grid>
            </Seccion>

            <Seccion titulo="Links Móviles Telemedicina">
              <Grid item xs={12} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="telemedicinaPantalla"
                      checked={
                        configuracion
                          ? configuracion.telemedicinapantalla
                          : false
                      }
                      onChange={(e) =>
                        set({ telemedicinapantalla: e.target.checked })
                      }
                    />
                  }
                  label="Pantalla"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="telemedicinaWhatsApp"
                      checked={
                        configuracion
                          ? configuracion.telemedicinawhatsapp
                          : false
                      }
                      onChange={(e) =>
                        set({ telemedicinawhatsapp: e.target.checked })
                      }
                      disabled={sinWhapi}
                    />
                  }
                  label="WhatsApp"
                />
              </Grid>
            </Seccion>

            <Seccion titulo="Recetas Telemedicina">
              <Grid item xs={12} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="recetasEmail"
                      checked={
                        configuracion ? configuracion.recetasemail : false
                      }
                      onChange={(e) => set({ recetasemail: e.target.checked })}
                    />
                  }
                  label="Email"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="recetasWhatsApp"
                      checked={
                        configuracion ? configuracion.recetaswhatsapp : false
                      }
                      onChange={(e) => set({ recetaswhatsapp: e.target.checked })}
                      disabled={sinWhapi}
                    />
                  }
                  label="WhatsApp"
                />
              </Grid>
            </Seccion>

            <Stack direction="row" spacing={1}>
              <Button
                variant="contained"
                startIcon={<CheckIcon />}
                onClick={aceptarClick}
              >
                Aceptar
              </Button>
              <Button variant="text" color="inherit" onClick={exitClick}>
                Cancelar
              </Button>
            </Stack>
          </Box>
        </ThemeProvider>
      ) : null}
    </Fragment>
  );
}
